import { render, staticRenderFns } from "./PropertiesSection.vue?vue&type=template&id=0abb8ee9&scoped=true"
import script from "./PropertiesSection.vue?vue&type=script&lang=js"
export * from "./PropertiesSection.vue?vue&type=script&lang=js"
import style0 from "./PropertiesSection.vue?vue&type=style&index=0&id=0abb8ee9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abb8ee9",
  null
  
)

export default component.exports